<template>
    <div>
        <component v-for="(button,index) in buttons" :is="button._component" :button="button" :key="index" :step="step"></component>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";

export default {
    mixins: [mixin],
    data() {
        return {
            field_name:'payment_type',
            buttons:[
                new Button('Compte bancaire', 'iban').nextStep('iban'),
                new Button('Carte de crédit', 'cc').nextStep('credit_card'),
            ]
        }
    },
    created() {
        this.step._field_name = this.field_name;
    }
}
</script>
